import { Icon } from '@hibro/ui-client';
import type { ReactNode } from 'react';

/**
 * The platform's one loading shape for a surface that has nothing to paint yet
 * (架构方案 §5.8): a centered spinner on the theme background, no text. Shared by
 * the inline-dom / fragment hosts (waiting on UI activation) and the `iframe`
 * host (waiting on the external page's `load`), so every surface reads the same.
 *
 * Its own file rather than `surface-host`: the iframe host needs it and
 * `surface-host` imports the iframe host, which would make that a cycle.
 */
export function SurfaceLoadingIndicator({
  label,
}: {
  label: string;
}): ReactNode {
  return (
    <div
      role="status"
      aria-label={label}
      className="flex h-full min-h-0 w-full flex-1 items-center justify-center text-muted-foreground"
    >
      <Icon
        className="animate-spin"
        spec={{ type: 'builtin', id: 'loader' }}
        size={24}
      />
    </div>
  );
}
